import { useState, useEffect } from 'react';
import { payAmigoClient } from '../api/payamigo';

interface UsePayAmigoSessionResult {
  sessionId: string | null;
}

export const usePayAmigoSession = (sessionIdFromUrl: string | undefined): UsePayAmigoSessionResult => {
  const [sessionId, setSessionId] = useState<string | null>(null);

  useEffect(() => {
    if (sessionIdFromUrl) {
      payAmigoClient.useExistingSession(sessionIdFromUrl);
      setSessionId(sessionIdFromUrl);
    }

    // Cleanup: delete session when component unmounts (widget closes)
    return () => {
      if (sessionIdFromUrl) {
        console.log('[PayAmigoSession] Cleaning up session:', sessionIdFromUrl);
        payAmigoClient.deleteSession().catch((error) => {
          console.error('[PayAmigoSession] Failed to delete session:', error);
        });
      }
    };
  }, [sessionIdFromUrl]);

  return {
    sessionId,
  };
};

